import firebase from 'firebase/app';
import 'firebase/firestore';
import "firebase/analytics";


firebase.initializeApp({
    apiKey: "AIzaSyDkRjCMrzV99h7mlmVQfGj6uuU_y43XJ6E",
    authDomain: "piday-2021.firebaseapp.com",
    databaseURL: "https://piday-2021-default-rtdb.firebaseio.com",
    projectId: "piday-2021",
    storageBucket: "piday-2021.appspot.com",
    messagingSenderId: "893630468446",
    appId: "1:893630468446:web:7c64459f7294e565b7bfcf",
    measurementId: "G-VZWX7JVGNW"
});

export const analytics = firebase.analytics();
export const db = firebase.firestore();